<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title"><i class="material-icons pointer" (click)="back()">arrow_left</i> Outstanding GRNs</h4>
					</div>
					<div class="card-body ogc">

						<!-- aging band -->
						<div class="ogc-band" *ngIf="summary?.totals">
							<div class="ogc-stat">
								<span class="ogc-stat__label">Open lines</span>
								<span class="ogc-stat__value">{{ summary.totals.lines_open || 0 }}</span>
								<span class="ogc-stat__sub">{{ summary.totals.batches_open || 0 }} GRNs · {{ summary.totals.vendors || 0 }} vendors</span>
							</div>
							<div class="ogc-stat">
								<span class="ogc-stat__label">Uninvoiced value</span>
								<span class="ogc-stat__value">{{ money(summary.totals.value_open) }}</span>
								<span class="ogc-stat__sub">accrued in A/P, no vendor bill</span>
							</div>
							<div class="ogc-stat">
								<span class="ogc-stat__label">Under 90 days</span>
								<span class="ogc-stat__value">{{ summary.totals.lines_under_90 || 0 }}</span>
								<span class="ogc-stat__sub">{{ money(summary.totals.value_under_90) }}</span>
							</div>
							<div class="ogc-stat ogc-stat--warn">
								<span class="ogc-stat__label">Over 90 days</span>
								<span class="ogc-stat__value">{{ summary.totals.lines_over_90 || 0 }}</span>
								<span class="ogc-stat__sub">{{ money(summary.totals.value_over_90) }}</span>
							</div>
							<div class="ogc-stat">
								<span class="ogc-stat__label">Never invoiced</span>
								<span class="ogc-stat__value">{{ summary.totals.lines_never_invoiced || 0 }}</span>
								<span class="ogc-stat__sub">PO line has no invoiced qty</span>
							</div>
						</div>

						<!-- vendor chips -->
						<div class="ogc-vendors" *ngIf="summary?.by_vendor?.length">
							<button type="button" class="ogc-chip" [class.ogc-chip--on]="!filters.supplierid" (click)="pickVendor('')">All vendors</button>
							<button type="button" class="ogc-chip" *ngFor="let v of summary.by_vendor"
								[class.ogc-chip--on]="filters.supplierid === v.supplierid"
								(click)="pickVendor(v.supplierid)"
								title="{{ v.suppname }} — oldest {{ v.oldest | date:'MM/dd/yyyy' }}">
								{{ v.supplierid }} <span class="ogc-chip__n">{{ v.lines_open }}</span> {{ money(v.value_open) }}
							</button>
						</div>

						<!-- tabs -->
						<div class="ogc-tabs">
							<button type="button" class="ogc-tab" [class.ogc-tab--on]="tab === 'open'" (click)="setTab('open')">Outstanding</button>
							<button type="button" class="ogc-tab" [class.ogc-tab--on]="tab === 'closed'" (click)="setTab('closed')">Closed log</button>
							<span class="ogc-spacer"></span>
							<button type="button" class="btn btn-success btn-sm" *ngIf="tab === 'open' && lines.length" (click)="exportXls()"><i class="fa fa-file-excel-o"></i></button>
							<button type="button" class="btn btn-danger btn-sm" *ngIf="tab === 'open' && lines.length" (click)="exportPdf()"><i class="fa fa-file-pdf-o"></i></button>
						</div>

						<div class="ogc-msg" *ngIf="msg" [ngClass]="'ogc-msg--' + msgKind">
							{{ msg }} <i class="material-icons pointer" (click)="msg = ''">close</i>
						</div>

						<!-- ============================================ outstanding -->
						<ng-container *ngIf="tab === 'open'">

							<div class="ogc-filters">
								<label>Age
									<select [(ngModel)]="filters.min_age_days" (change)="loadLines()">
										<option *ngFor="let a of agePresets" [ngValue]="a.value">{{ a.label }}</option>
									</select>
								</label>
								<label>Received from <input type="date" [(ngModel)]="filters.from" (change)="loadLines()"></label>
								<label>to <input type="date" [(ngModel)]="filters.to" (change)="loadLines()"></label>
								<label>Search
									<input type="text" [(ngModel)]="filters.search" (keyup.enter)="loadLines()" placeholder="GRN, PO, item…">
								</label>
								<label class="ogc-chk"><input type="checkbox" [(ngModel)]="filters.never_invoiced" (change)="loadLines()"> Never invoiced only</label>
								<button type="button" class="btn btn-primary btn-sm" (click)="loadLines()">Apply</button>
								<button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearFilters()">Clear</button>
							</div>

							<div class="ogc-count" *ngIf="!loadingLines">
								{{ lines.length }} line(s) · {{ money(openValueTotal) }} uninvoiced
							</div>
							<div class="ogc-count" *ngIf="loadingLines">Loading…</div>

							<div class="table-responsive ogc-tablewrap" #print_table>
								<table class="table table-sm table-hover ogc-table">
									<thead>
										<tr>
											<th class="ogc-cb"><input type="checkbox" [checked]="allChecked" (change)="toggleAll($any($event.target).checked)"></th>
											<th>Vendor</th>
											<th>GRN#</th>
											<th>Batch</th>
											<th>PO#</th>
											<th>PO status</th>
											<th>Received</th>
											<th class="text-center">Age</th>
											<th>Item</th>
											<th>Description</th>
											<th class="text-center">Ord</th>
											<th class="text-center">Recd</th>
											<th class="text-center">Invoiced</th>
											<th class="text-right">Unit</th>
											<th class="text-right">Open value</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let l of lines" [class.ogc-row--on]="selected[l.grnno]">
											<td class="ogc-cb"><input type="checkbox" [(ngModel)]="selected[l.grnno]"></td>
											<td>{{ l.supplierid }}</td>
											<td>{{ l.grnno }}</td>
											<td>{{ l.grnbatch }}</td>
											<td>{{ l.orderno }}</td>
											<td>{{ l.po_status }}</td>
											<td>{{ l.deliverydate | date:'MM/dd/yyyy' }}</td>
											<td class="text-center" [ngClass]="ageClass(l)">{{ l.age_days == null ? 'no date' : l.age_days + 'd' }}</td>
											<td>{{ l.itemcode }}</td>
											<td>{{ l.itemdescription }}</td>
											<td class="text-center">{{ l.quantityord }}</td>
											<td class="text-center">{{ l.qtyrecd }}</td>
											<td class="text-center">{{ l.qtyinvoiced }}</td>
											<td class="text-right">{{ l.unitprice | currency }}</td>
											<td class="text-right">{{ l.open_value | currency }}</td>
										</tr>
										<tr *ngIf="!lines.length && !loadingLines">
											<td colspan="15" class="ogc-empty">Nothing outstanding for these filters.</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!-- action bar -->
							<div class="ogc-actionbar" *ngIf="selectedCount">
								<div class="ogc-actionbar__sel">
									<strong>{{ selectedCount }}</strong> selected · <strong>{{ money(selectedValue) }}</strong>
								</div>
								<input type="text" class="ogc-reason" [(ngModel)]="reason" maxlength="255"
									placeholder="Reason (required) — e.g. zero-qty ghost, internal transfer, bill keyed to G/L">
								<button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="closing" (click)="close()">
									Close off the list
								</button>
							</div>
							<div class="ogc-note" *ngIf="selectedCount">
								Closing posts <strong>no G/L</strong> — the accrual stays exactly where the receipt put it. This only takes
								the line off Outstanding GRNs and off the Add Vendor Invoice picker. Reversible from the Closed log.
							</div>
						</ng-container>

						<!-- ================================================ closed log -->
						<ng-container *ngIf="tab === 'closed'">
							<div class="ogc-filters">
								<label>Closed from <input type="date" [(ngModel)]="closureFilters.from" (change)="loadClosures()"></label>
								<label>to <input type="date" [(ngModel)]="closureFilters.to" (change)="loadClosures()"></label>
								<label>Status
									<select [(ngModel)]="closureFilters.reversed" (change)="loadClosures()">
										<option value="">All</option>
										<option value="0">Closed</option>
										<option value="1">Reversed</option>
									</select>
								</label>
								<button type="button" class="btn btn-primary btn-sm" (click)="loadClosures()">Apply</button>
							</div>

							<div class="ogc-count" *ngIf="loadingClosures">Loading…</div>

							<div class="table-responsive ogc-tablewrap">
								<table class="table table-sm table-hover ogc-table">
									<thead>
										<tr>
											<th>Closed</th>
											<th>By</th>
											<th>Vendor</th>
											<th>GRN#</th>
											<th>PO#</th>
											<th>Item</th>
											<th class="text-center">Qty</th>
											<th class="text-right">Value</th>
											<th>Reason</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let c of closures" [class.ogc-row--rev]="c.reversed == 1">
											<td>{{ c.closed_at | date:'MM/dd/yyyy HH:mm' }}</td>
											<td>{{ c.closed_by }}</td>
											<td>{{ c.supplierid }}</td>
											<td>{{ c.grnno }}</td>
											<td>{{ c.orderno }}</td>
											<td>{{ c.itemcode }}</td>
											<td class="text-center">{{ c.qty_closed }}</td>
											<td class="text-right">{{ c.close_value | currency }}</td>
											<td class="ogc-reasoncell">{{ c.reason }}</td>
											<td class="text-right">
												<span class="ogc-reversed" *ngIf="c.reversed == 1">reversed {{ c.reversed_at | date:'MM/dd/yy' }}</span>
												<button type="button" class="btn btn-outline-secondary btn-sm" *ngIf="c.reversed != 1" (click)="reverseClosure(c)">Reverse</button>
											</td>
										</tr>
										<tr *ngIf="!closures.length && !loadingClosures">
											<td colspan="12" class="ogc-empty">Nothing closed yet.</td>
										</tr>
									</tbody>
								</table>
							</div>
						</ng-container>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>
